import { ChevronDown, Loader2 } from "lucide-react";

import { ChatSession } from "../stores/types";

import { cn } from "@/lib/utils";
import { ChatSession as APIChatSession } from "@/queries/vibe/useRecentVibeChatSessions";

interface ChatSessionTriggerProps {
  currentChat: ChatSession | undefined;
  chatSessions: APIChatSession[];
  currentChatId: string;
  isMaximized?: boolean;
}

export const ChatSessionTrigger = ({
  currentChat,
  chatSessions,
  currentChatId,
  isMaximized = false,
}: ChatSessionTriggerProps) => {
  const displayTitle =
    currentChat?.title || chatSessions.find(c => c.id === currentChatId)?.name || "New chat";

  return (
    <>
      {currentChat?.isGeneratingName && (
        <Loader2 className="size-3 shrink-0 animate-spin text-gray-400" />
      )}
      <span className={cn("min-w-0 max-w-[286px] truncate", isMaximized ? "text-sm" : "text-xs")}>
        {displayTitle}
      </span>
      <ChevronDown className="size-3 shrink-0 text-gray-400 transition-transform group-data-[state=open]:rotate-180" />
    </>
  );
};
